import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { useRouter } from 'next/router';
import storage from 'local-storage-fallback';
import { sendEvent as gaSendEvent } from './ga';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { logGabitoEvent, logNonAuthGabitoEvent } from '@mrkt/features/gabito';
import { createFrodorPageEventNonAuth } from '@spotify-internal/event-definitions/es5/events/createFrodorPageEventNonAuth';
import { createFrodorPageEvent } from '@spotify-internal/event-definitions/es5/events/createFrodorPageEvent';
export function useTracking() {
  var user = useCurrentUser();
  var userRef = React.useRef(user);
  var router = useRouter();
  var routerRef = React.useRef(router);
  React.useEffect(function () {
    userRef.current = user;
    routerRef.current = router;
  }, [user, router]);
  return {
    sendEvent: function sendEvent(opts) {
      var _routerRef$current;

      _sendEvent(_objectSpread({
        user: userRef.current,
        pathname: (_routerRef$current = routerRef.current) === null || _routerRef$current === void 0 ? void 0 : _routerRef$current.asPath
      }, opts));
    },
    eventHandler: function eventHandler(eventCategory, eventLabel) {
      var _routerRef$current2;

      return _eventHandler(eventCategory, eventLabel, userRef.current, (_routerRef$current2 = routerRef.current) === null || _routerRef$current2 === void 0 ? void 0 : _routerRef$current2.asPath);
    },
    eventHandlerWithAction: function eventHandlerWithAction(eventCategory, eventAction, eventLabel) {
      var _routerRef$current3;

      return _eventHandlerWithAction(eventCategory, eventAction, eventLabel, userRef.current, (_routerRef$current3 = routerRef.current) === null || _routerRef$current3 === void 0 ? void 0 : _routerRef$current3.asPath);
    }
  };
} // methods are exported only for legacy code, please use useTracking hook
// for all new code ^^^

function _sendEvent(opts) {
  var eventCategory = opts.eventCategory,
      eventAction = opts.eventAction,
      eventLabel = opts.eventLabel,
      user = opts.user;
  var gaEvent = {
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel
  };
  debug('sending GA event', gaEvent);
  gaSendEvent(gaEvent);
  var href = true ? window.location.href : opts.pathname;
  var pathname = true ? window.location.pathname : opts.pathname;

  if (user) {
    var _user$partnerIds;

    var artistId;

    if (user.username) {
      artistId = storage.getItem("".concat(user.username, ":analytics:lastVisitedArtist"));
    }

    var gabitoEvent = {
      url: href,
      pathname: pathname,
      title: document.title,
      partner_id: (_user$partnerIds = user.partnerIds) === null || _user$partnerIds === void 0 ? void 0 : _user$partnerIds.google,
      is_employee: null,
      has_access: user.hasAccess,
      artist_id: artistId,
      category: eventCategory,
      action: eventAction,
      label: eventLabel
    };
    debug('sending gabito auth event', gabitoEvent);
    logGabitoEvent(createFrodorPageEvent(gabitoEvent));
  } else {
    var _gabitoEvent = {
      url: href,
      pathname: pathname,
      title: document.title,
      category: eventCategory,
      action: eventAction,
      label: eventLabel
    };
    debug('sending gabito non-auth event', _gabitoEvent);
    logNonAuthGabitoEvent(createFrodorPageEventNonAuth(_gabitoEvent));
  }
}

export { _sendEvent as sendEvent };

function _eventHandler(eventCategory, eventLabel, user, pathname) {
  return function (e) {
    return _sendEvent({
      eventCategory: eventCategory,
      eventAction: e.type,
      eventLabel: eventLabel,
      user: user,
      pathname: pathname
    });
  };
}

export { _eventHandler as eventHandler };

function _eventHandlerWithAction(eventCategory, eventAction, eventLabel, user, pathname) {
  return function () {
    return _sendEvent({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      user: user,
      pathname: pathname
    });
  };
}

export { _eventHandlerWithAction as eventHandlerWithAction };

function debug() {
  if (true && (window.location.search || '').includes('debug_tracking')) {
    var _console;

    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, arguments);
  }
}

export { Track } from './Track';